import { z } from 'zod'

export const pixelDrawingBoundsSchema = z.object({
  x_start: z.number(),
  y_start: z.number(),
  x_end: z.number(),
  y_end: z.number(),
})
